import styled from 'styled-components';

export const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  > *:only-child {
    margin-left: auto;
  }
`;
